import utransferV2API from "./utransferV2";

export const forgotPassword = async (email) => {
  await utransferV2API.post(`/password/forgot`, { email });
};
